import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Popup from "../../../base-components/Popup";
import CustomModal from "../../../base-components/CustomModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faDownload } from '@fortawesome/free-solid-svg-icons';
import { Select, MenuItem } from "@mui/material";
import {
  faEye,
  faPen,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import TablePaginationActions from "../../../base-components/TablePaginationActions";
import { Box, Table, TableBody, CircularProgress, TableCell, TableFooter, TableHead, TablePagination, TableRow, Button, IconButton, Menu } from "@mui/material";
import { useFormik } from "formik";
import Tooltip from "@mui/material/Tooltip";
import PhoneInput from "react-phone-input-2";
import { visitorValidationSchema } from "../../../schemas";
import { Report } from "./Report";
import dayjs from "dayjs";
import VisitorStatsModal from "./StatsModal";
import BarChartIcon from '@mui/icons-material/BarChart';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { encodedImagesURI } from '../../../utils/helpers.js';
import { getSessionUser, hasAnyPermission, hasPermission, isDynamicStaffRole } from '../../../utils/roleAccess';
import defaultUser from '../../../images/user_default.jpg'
import { PageHeader } from "../../../ui";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function Visitor() {
  const navigate = useNavigate();
  const [visitorToDelete, setVisitorToDelete] = useState("");
  const [visitorToUpdate, setVisitorToUpdate] = useState("");
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  const [isSuccessAlert, setIsSuccessAlert] = useState(false);
  const [isFaliureAlert, setIsFailureAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failureMessage, setFailureMessage] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const [locations, setLocations] = useState([]);
  const [visitors, setVisitors] = useState([]);
  const [filtered_visitors, setFilteredVisitors] = useState([]);
  const [selectedVisitor, setSelectedMember] = useState(null);
  const [company_id, setCompanyID] = useState("");
  const [user_id, setUserId] = useState("");
  const [location_id, setLocationId] = useState("");
  const [role, setRole] = useState("");
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const location = useLocation();

  const [fromDate , setFromDate] = useState();
  const [toDate , setToDate] = useState();
  const [visitorFilter , setVisitorFilter] = useState();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState();

  // State and method for Stats Modal
  const [isStatsModalOpen, setIsStatsModalOpen] = useState(false);
  const handleOpenStatsModal = () => {
    setIsStatsModalOpen(true);
  };

     // Anchor state for the actions menu
      const [anchorEl, setAnchorEl] = useState(null);
      const [selectedVisitorId, setSelectedVisitorId] = useState(null);
      const openAnchor = Boolean(anchorEl);
      const handleClickAnchor = (event, visitorId) => {
        setAnchorEl(event.currentTarget);
        setSelectedVisitorId(visitorId);
      };
      const handleCloseAnchor = () => {
        setAnchorEl(null);
        setSelectedVisitorId(null);
      };

  useEffect(() => {
    const sessionStr = sessionStorage.getItem("user-info");
    if (sessionStr) {
      const session = JSON.parse(sessionStr);
      setRole(session.user.role);
      setUserId(session.user._id);
      setCompanyID(session.user.company_id);
      setLocationId(session.user.location_id);
      console.log("ha bhai", session.user.company_id);
      console.log("roleee", session.user.role);
    } else {
      navigate("/login");
    }
  }, []);

  // const getAllVisitor = () => {
  //   if (!role) return;

  //   let endpoint = "";
  //   console.log("gf",role);
  //   if (role === "SuperAdmin") {
  //     endpoint = `visitors/get-all-visitors`;
  //   } else if (role === "Admin") {
  //     endpoint = `visitors/getVisitorsByCompanyID/${company_id}`;
  //   } else if (role === "ClubAdmin") {
  //     endpoint = `visitors/getVisitorsByLocationID/${location_id}`;
  //   }

  //   console.log("Role:", role);
  //   console.log("Company ID:", company_id);
  //   console.log("Endpoint:", endpoint);
  //   fetch(BASE_URL + endpoint)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       setVisitor(data.visitor);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching gym assets:", error); // Log the error
  //       setLoading(false); // Ensure loading stops even in case of an error
  //     });
  // };

  const getAllVisitor = async () => {
    try {
      if (!role) return;

      let endpoint = "";
      console.log("Role:", role);

      if (role === "SuperAdmin") {
        endpoint = `visitors/get-all-visitors`;
      } else if (role === "Admin" && company_id) {
        endpoint = `visitors/getVisitorsByCompanyID/${company_id}`;
      } else if (role === "ClubAdmin" && location_id) {
        endpoint = `visitors/getVisitorsByLocationID/${location_id}`;
      } else if (isDynamicStaffRole(role) && location_id) {
        endpoint = `visitors/getVisitorsByLocationID/${location_id}`;
      } else {
        console.warn("Invalid role or missing ID");
        return;
      }

      console.log("Company ID:", company_id);
      console.log("Location ID:", location_id);
      console.log("Endpoint:", endpoint);

      setLoading(true); // Start loading
      const response = await fetch(`${BASE_URL}${endpoint}`);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setVisitors(data.visitors);
      setFilteredVisitors(data.visitors);
      console.log("visitors", visitors);
    } catch (error) {
      console.error("Error fetching visitors:", error);
    } finally {
      setLoading(false); // Stop loading in any case
    }
  };
  useEffect(() => {
    if (role) {
      setLoading(true);
      getLocation();
      getCountries();
      getAllVisitor();
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, [role]);
  const getVisitorById = (_id) => {
    fetch(`${BASE_URL}visitors/get-visitor/${_id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.visitor) {
          setSelectedMember(data.visitor);
          setValues({
            name: data.visitor.name,
            company_id: data.visitor.company_id,
            location_id: data.visitor.location_id,
            email: data.visitor.email,
            country: data.visitor.country,
            phone: data.visitor.phone,
            address: data.visitor.address,
            state: data.visitor.state,
            city: data.visitor.city,
            postal_code: data.visitor.postal_code,
            cnic: data.visitor.cnic,
            age: data.visitor.age,
            gender: data.visitor.gender,
            height: data.visitor.height,
            height_units: data.visitor.height_units,
            weight: data.visitor.weight,
            weight_units: data.visitor.weight_units,
            disease: data.visitor.disease,
            photo: data.visitor.photo || null,
            trial_start_date: data.visitor.trial_start_date ? dayjs(data.visitor.trial_start_date).format('YYYY-MM-DD') : '',
            trial_end_date: data.visitor.trial_end_date ? dayjs(data.visitor.trial_end_date).format('YYYY-MM-DD') : '',
          });
          console.log("asd", data.visitor);
        } else {
          console.error("No visitor found.");
          setIsFailureAlert(true);
          setFailureMessage("No visitor  found for the provided ID.");
          setIsPopupOpen(true);
          setTimeout(() => {
            setIsPopupOpen(false);
          }, 5000);
        }
      })
      .catch((error) => {
        console.error("Error fetching visitor  by ID:", error);
        setIsFailureAlert(true);
        setFailureMessage("Failed to fetch visitor information.");
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      });
  };

  async function getCountries() {
    return fetch(BASE_URL + `country/getCountries`)
      .then((response) => response.json())
      .then((data) => {
        setCountries(data);
      })
      .catch((error) => console.log(error));
  }

  const getStates = async (value) => {
    await fetch(BASE_URL + `country/getStatesById/${value}`)
      .then((response) => response.json())
      .then((data) => {
        setStates(data);
      })
      .catch((error) => console.log(error));
  };
console.log("states 12",states)
  const getCities = async (value) => {
    await fetch(BASE_URL + `country/getCitiesById/${value}`)
      .then((response) => response.json())
      .then((data) => {
        setCities(data);
      })
      .catch((error) => console.log(error));
  };

  async function getLocation() {
    if (!role) return;

    let endpoint = "";
    console.log(role);
    if (role === "SuperAdmin") {
      endpoint = "locations/getLocations";
    } else if (role === "Admin") {
      endpoint = `locations/getLocationsByCompanyID/${company_id}`;
    }

    await fetch(BASE_URL + endpoint)
      .then((response) => response.json())
      .then((data) => {
        setLocations(data.locations);
      })
      .catch((error) => {
        console.log(error);
      });
  }
console.log("loccc",locations)
  const handleAddVisitor = async (values, actions) => {
    setButtonLoading(true);
    console.log("Values before save:", values);
    values.company_id = company_id;
    const formData = new FormData();
    Object.keys(values).forEach((key) => {
      if (key === 'photo' && values[key]) {
        formData.append(key, values[key], 'photo.jpg'); 
      } else {
        formData.append(key, values[key]); 
      }
    });
    const requestOptions = {
      method: "POST",
      body: formData,
    };

    try {
      const response = await fetch(
        BASE_URL + `visitors/create-visitor`,
        requestOptions
      );

      console.log("Response status:", response.status);

      if (!response.ok) {
        const errorMessage = await response.text();
        console.error("Error message from server:", errorMessage);
        setIsFailureAlert(true);
        setFailureMessage(`Failed to add Visitor: ${errorMessage}` + (errorMessage.machineMessage ? ` - Machine Response: ${errorMessage.machineMessage}` : ''));
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        const responseData = await response.json();
        console.log("Response data:", responseData);

        // if ( responseData.visitor) {
        setIsAddModalOpen(false);
        actions.resetForm();
        getAllVisitor();
        setIsSuccessAlert(true);
        setSuccessMessage(responseData.message + (responseData.machineMessage ? ` - Machine Response: ${responseData.machineMessage}` : ''));
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
        // }
        // else {
        //   console.error("Unexpected response data:", responseData);
        //   setIsFailureAlert(true);
        //   setFailureMessage(responseData.message);
        //   setIsPopupOpen(true);
        //   setTimeout(() => {
        //     setIsPopupOpen(false);
        //   }, 5000);
        // }
      }
    } catch (error) {
      console.error("Caught error:", error);
      setIsFailureAlert(true);
      setFailureMessage("Failed to add Visitor" + (error.machineMessage ? ` - Machine Response: ${error.machineMessage}` : ''));
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
    } finally {
      setButtonLoading(false); // Stop loading in any case
      setImagePreview(null);
    }
  };
  console.log("ffc", company_id);

  const handleUpdateVisitor = async (values, actions) => {
    setButtonLoading(true);
    values.company_id = company_id;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(values),
    };

    try {
      const response = await fetch(
        `${BASE_URL}visitors/update-visitor/${visitorToUpdate}`,
        requestOptions
      );

      if (!response.ok) {
        const responseData = await response.json();
        setIsFailureAlert(true);
        setFailureMessage(responseData.message);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      } else {
        const responseData = await response.json();
        actions.resetForm();
        setIsUpdateModalOpen(false);

        getAllVisitor();
        setIsSuccessAlert(true);
        setSuccessMessage(responseData.message);
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }
    } catch (error) {
      console.error("Caught error:", error);
      setIsFailureAlert(true);
      setFailureMessage("Failed to Update Visitor");
      setIsPopupOpen(true);
      setTimeout(() => {
        setIsPopupOpen(false);
      }, 5000);
    } finally {
      setButtonLoading(false);
    }
  };
  console.log("update", company_id);
  

  function deleteVisitor() {
    setButtonLoading(true)
    const requestOptions = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    };
    fetch(
      BASE_URL + `visitors/delete-visitor/${visitorToDelete}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => {
        getAllVisitor();
        setIsDeleteModalOpen(false);
        setIsSuccessAlert(true);
        setSuccessMessage("Visitor deleted Successfully" + (data.machineMessage ? ` - Machine Response: ${data.machineMessage}` : ''));
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      })
      .catch((error) => {
        console.log(error);
        setIsFailureAlert(true);
        setFailureMessage("Failed to delete Visitor" + (error.machineMessage ? ` - Machine Response: ${error.machineMessage}` : ''));
        setIsPopupOpen(true);
        setTimeout(() => {
          setIsPopupOpen(false);
        }, 5000);
      }).finally(() => {
        setButtonLoading(false);
      });
  }

  function toggleAddModal() {
    setIsAddModalOpen(!isAddModalOpen);
    resetForm();
    setImagePreview(null);
  }
  function toggleViewModal() {
    setIsViewModalOpen(!isViewModalOpen);
    resetForm();
    setImagePreview(null);
  }

  function toggleUpdateModal() {
    setIsUpdateModalOpen(!isUpdateModalOpen);
    resetForm();
    setImagePreview(null);
  }
  function toggleDeleteModal() {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  }

  function showAddModal(_id) {
    setIsAddModalOpen(true);
  }
  function showViewModal(_id) {
    getVisitorById(_id);
    setIsViewModalOpen(true);
  }
  const showUpdateModal = (_id) => {
    getVisitorById(_id);
    setVisitorToUpdate(_id);
    setIsUpdateModalOpen(true);
  };

  function showDeleteModal(id) {
    setVisitorToDelete(id);
    setIsDeleteModalOpen(true);
  }


  const handleDownload=()=>{
    Report(filtered_visitors)
  }

  const handleFilter = () => {
    setLoading(true);
    let filtered = visitors; 
    console.log(filtered);

    if (fromDate && toDate) {
        const startFilterDate = new Date(fromDate);
        startFilterDate.setHours(0, 0, 0, 0);

        const endFilterDate = new Date(toDate);
        endFilterDate.setHours(23, 59, 59, 999);

        console.log("startFilterDate : ",startFilterDate);
        console.log("endFilterDate : ",endFilterDate);
        filtered = filtered.filter(visitor => {
            const visitorDate = new Date(visitor?.created_at);
            console.log("visit date : ", visitorDate);
            console.log(visitorDate >= startFilterDate && visitorDate <= endFilterDate);
            return visitorDate >= startFilterDate && visitorDate <= endFilterDate;
        });
    }
  
    if(visitorFilter){
      if(visitorFilter === 'male'){
          filtered = filtered.filter(visitor => 
              visitor.gender === 'male'
          );
      }else if(visitorFilter === 'female'){
          filtered = filtered.filter(visitor => 
              visitor.gender === 'female'
          );
      }
    }
    console.log("Filtered Vouchers:", filtered);
    setFilteredVisitors(filtered);
    
    setTimeout(() => {
        setLoading(false);
    }, 1000);
  };
  // function handlePrint(visitor) {
  //   navigate("/profilemember", {
  //     state: { prevPath: location.pathname, id: visitor },
  //   });
  // }

  const paginatedVisitors = !filtered_visitors || filtered_visitors.length === 0 ?
    [] :
     rowsPerPage === -1
    ? filtered_visitors // Show all if "All" option is selected
    : filtered_visitors.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const {
    values,
    touched,
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      phone: "",
      email: "",
      address: "",
      country: "",
      state: "",
      city: "",
      postal_code: "",
      cnic: "",
      age: "",
      gender: "male",
      height: "",
      height_units: "ft",
      weight: "",
      weight_units: "kg",
      disease: "",
      company_id: "",
      location_id: role === "ClubAdmin" ? location_id : "",
      trial_start_date: "",
      trial_end_date: "",
      photo: null,
    },
    validationSchema: visitorValidationSchema,
    onSubmit: (values, actions) => {
      console.log("Form Submitted:", values);

      if (isAddModalOpen) {
        handleAddVisitor(values, actions);
      } else if (isUpdateModalOpen) {
        handleUpdateVisitor(values, actions);
      } else {
        console.error("No valid action specified for submission.");
      }
    },
  });
  console.log(values, "values");

  const handleImageUpload = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
      setFieldValue("photo", file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  return (
    <>
      <div className="m-5">
        <PageHeader
          title="Visitor"
          actions={
            <>
              {hasPermission(getSessionUser(), 'reporting:export') && (
              <div className="text-gx-navy hover:cursor-pointer hover:text-gx-teal">
                <Tooltip title="Download" arrow>
                  <FontAwesomeIcon icon={faDownload} fontSize="30px" onClick={handleDownload} />
                </Tooltip>
              </div>
              )}
              {hasPermission(getSessionUser(), 'visitors:create') && (
              <button className="gx-cta" onClick={showAddModal}>
                Add Visitor
              </button>
              )}
            </>
          }
        />
      </div>
      {/* <div className="w-[93%] my-3 mx-2 md:mx-8 relative">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
          className="border border-gx-border rounded-md py-1 px-2 pl-10 outline-0 w-full md:w-72"
        />
        <FontAwesomeIcon icon={faSearch} className="absolute left-3 top-2 text-gx-ink-soft" />
      </div> */}
      <div className='flex m-5'>
        <Button 
            variant="contained"
            color="primary"
            startIcon={<BarChartIcon />}
            className="bg-gx-red hover:bg-[#ff0008] text-white font-bold rounded-lg relative overflow-hidden" 
          onClick={handleOpenStatsModal}
        >
          View Stats
        </Button>
      </div>
      <div className='flex flex-col lg:flex-row items-start lg:items-center justify-start gap-4 lg:gap-16 px-2 md:px-0 m-5'>
        <div className="w-full md:w-auto">
          <form onSubmit={(e) => e.preventDefault()} className="flex flex-col gap-2 md:gap-4">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-4 lg:gap-8">
              <div className="flex items-center gap-2 w-full md:w-auto">
                <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">From Date:</label>
                <input
                  type="date"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  className="border border-gx-border rounded-md py-1 px-3 outline-0 text-gx-ink-soft w-full md:w-48"
                />
              </div>
            
              <div className="flex items-center gap-2 w-full md:w-auto">
                <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">End Date:</label>
                <input
                  type="date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  disabled={!fromDate} 
                  min={fromDate}
                  className="border border-gx-border rounded-md py-1 px-3 outline-0 w-full md:w-48"
                />
              </div>
            </div>
            <div className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-4 w-full">
              <label className="text-gx-ink font-semibold whitespace-nowrap text-sm md:text-base">Select Filter</label>
              <Select className='w-full md:w-[200px] bg-white h-9' value={visitorFilter}
                onChange={(e) => setVisitorFilter(e.target.value)}
              >
                <MenuItem value='none'>None</MenuItem>
                <MenuItem value='male'>Male</MenuItem>
                <MenuItem value='female'>Female</MenuItem>
              </Select>
              <div className='w-full md:w-auto'>
                <button onClick={handleFilter} className="bg-green-700 text-white hover:bg-green-800 py-1 px-4 rounded-md flex items-center justify-center gap-4 w-full md:w-auto mt-2 md:mt-0">
                  Fetch Visitors
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      { loading ? (
          
            <div className="flex justify-center items-center mt-20 relative">
              {/* SVG Gradient Definition */}
              <svg width="0" height="0">
                <defs>
                  <linearGradient id="gradientColors" x1="1" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#D71920" />
                    <stop offset="100%" stopColor="#F7931E" />
                  </linearGradient>
                </defs>
              </svg>
      
              {/* Circular Progress with Gradient Stroke */}
              <CircularProgress
                thickness={4}
                size={35}
                sx={{
                  'svg circle': {
                    stroke: 'url(#gradientColors)', // Apply gradient stroke
                  },
                }}
              />
            </div>
          
        ) :  filtered_visitors && filtered_visitors.length !== 0 ? (
        <Box className="bg-gx-surface rounded-gx border border-gx-border shadow-gx m-5 animate-fadeIn overflow-y-auto overflow-x-auto">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Photo</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone Number </TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Gender</TableCell>
                <TableCell>Visit Date</TableCell>
                {hasAnyPermission(getSessionUser(), ['visitors:update', 'visitors:delete']) && <TableCell>Actions</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedVisitors.map((visitor, index) => (
                <TableRow hover key={index}>
                  <TableCell>
                      <div className="w-20 h-20 rounded-full overflow-hidden border border-gx-border">
                          <img
                              src={encodedImagesURI(visitor.photo) || defaultUser}
                              alt={visitor.name}
                              className="w-full h-full object-cover"
                              onError={(e) => (e.target.src = defaultUser)}
                          />
                      </div>
                  </TableCell>
                  <TableCell>{visitor.name}</TableCell>
                  <TableCell>{visitor.email}</TableCell>
                  <TableCell>{visitor.phone}</TableCell>
                  <TableCell>{visitor.address}</TableCell>
                  <TableCell>{visitor.gender.charAt(0).toUpperCase() + visitor.gender.slice(1)}</TableCell>
                  <TableCell>{dayjs(visitor.created_at).format("MMM DD, YYYY")}</TableCell>
                  <TableCell>
                    {hasAnyPermission(getSessionUser(), ['visitors:update', 'visitors:delete']) && (
                      <div className="flex gap-2">                        
                        <Tooltip title="Actions">
                          <IconButton onClick={(event) => handleClickAnchor(event, visitor._id)}>
                            <MoreVertIcon />
                          </IconButton>
                        </Tooltip>
                        <Menu anchorEl={anchorEl} open={openAnchor} onClose={handleCloseAnchor}>
                          <MenuItem
                            onClick={() => {
                              handleCloseAnchor();
                              showViewModal(selectedVisitorId);
                            }}
                          >
                            <FontAwesomeIcon icon={faEye} className='mr-2'/> View 
                          </MenuItem>
                          {hasPermission(getSessionUser(), 'visitors:update') && (
                          <MenuItem
                            onClick={() => {
                              handleCloseAnchor();
                              showUpdateModal(selectedVisitorId);
                            }}
                          >
                            <FontAwesomeIcon icon={faPen} className='mr-2' /> Update
                          </MenuItem>
                          )}
                          {hasPermission(getSessionUser(), 'visitors:delete') && (
                          <MenuItem
                            onClick={() => {
                              handleCloseAnchor();
                              showDeleteModal(selectedVisitorId);
                            }}
                          >
                            <FontAwesomeIcon icon={faTrash} className='mr-2'/> Delete
                          </MenuItem>
                          )}
                        </Menu>
                        {/* <div>
                          <Button>Convert to Member</Button>
                        </div> */}
                      </div>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                  colSpan={12}
                  count={filtered_visitors.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  slotProps={{
                    select: {
                      inputProps: {
                        "aria-label": "rows per page",
                      },
                      native: true,
                    },
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </Box>
      ) : (
        <div className="bg-gx-border w-ful p-3 mt-10 rounded-lg m-10">
          <h3 className="text-xl font-bold text-center text-gx-ink-soft">
            No Records Found
          </h3>
        </div>
      )}
<CustomModal
  isModal={isAddModalOpen || isUpdateModalOpen}
  handleModal={() => {
    if (isAddModalOpen) {
      toggleAddModal();
    } else if (isUpdateModalOpen) {
      toggleUpdateModal();
    }
  }}
  size="2xl"
>
  <h1 className="font-bold text-xl md:text-2xl lg:text-3xl text-gx-ink-soft p-3 md:p-5 border-b mx-2">
    {isAddModalOpen ? "Add Visitor" : "Update Visitor"}
  </h1>

  <form
    onSubmit={handleSubmit}
    className="text-gx-ink-soft m-3 md:m-5"
    autoComplete="off"
  >
    <div>
      <input type="hidden" name="company_id" value={values.company_id} />
    </div>

    <div className="w-full flex justify-center items-center">
      <div className="w-full md:w-[400px]">
        <label className="block mb-2 text-center font-medium">
          Upload Image
        </label>
        <div className="flex flex-col items-center gap-3">
          {/* Image Preview */}
          <div className="w-[250px] h-[250px] bg-gx-border rounded-xl flex items-center justify-center overflow-hidden">
            <img
              src={imagePreview || encodedImagesURI(values.photo) || defaultUser} // your default image path
              alt="Preview"
              className="object-cover w-full h-full"
            />
          </div>

          {/* File Input */}
          <input
            type="file"
            name="image"
            accept="image/*"
            onChange={handleImageUpload}
            className="border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0"
          />
        </div>
      </div>
    </div>

    <div className="flex flex-col md:flex-row justify-between gap-3 md:gap-5 mt-3 md:mt-4">
      <div className="w-full mb-3 md:mb-0">
        <label className="block mb-1">
          Name <span className="text-red-600">*</span>
        </label>
        <input
          type="text"
          name="name"
          placeholder="Enter Name"
          value={values.name}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.name && touched.name ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.name && errors.name ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.name}</p>
        ) : null}
      </div>
      <div className="w-full">
        <label className="block mb-1">
          Phone <span className="text-red-600">*</span>
        </label>
        <PhoneInput
          name='phone'
          country={"pk"}
          value={values.phone}
          onChange={(value) => setFieldValue("phone", value)}
          inputStyle={{ width: "100%" }}
          containerStyle={{ width: "100%" }}
        />
        {touched.phone && errors.phone ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.phone}</p>
        ) : null}
      </div>
    </div>

    <div className="flex flex-col md:flex-row justify-between gap-3 md:gap-5 mt-3 md:mt-5">
      <div className="w-full mb-3 md:mb-0">
        <label className="block mb-1">
          Age <span className="text-red-600">*</span>
        </label>
        <input
          type="number"
          name="age"
          placeholder="Enter Age"
          value={values.age}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.age && touched.age ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.age && errors.age ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.age}</p>
        ) : null}
      </div>
      <div className="w-full">
        <label className="block mb-1">
          CNIC <span className="text-red-600">*</span>
        </label>
        <input
          type="text"
          name="cnic"
          placeholder="Enter CNIC"
          value={values.cnic}
          maxLength={13}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.cnic && touched.cnic ? "border-red-600" : "")
          }
          onChange={(e) => {
            const numericValue = e.target.value.replace(/\D/g, ""); 
            handleChange({
              target: { name: "cnic", value: numericValue },
            });
          }}
          onBlur={handleBlur}
        />
        {touched.cnic && errors.cnic ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.cnic}</p>
        ) : null}
      </div>
    </div>

    <div className="flex flex-col md:flex-row justify-between gap-3 md:gap-5 mt-3 md:mt-5">
      <div className="w-full mb-3 md:mb-0">
        <label className="block mb-1">
          Gender <span className="text-red-600">*</span>
        </label>
        <select
          name="gender"
          placeholder="Select Gender"
          value={values.gender}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.gender && touched.gender ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>
        {touched.gender && errors.gender ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.gender}</p>
        ) : null}
      </div>

      <div className="w-full">
        <label className="block mb-1">
          Email <span className="text-red-600">*</span>
        </label>
        <input
          type="email"
          name="email"
          placeholder="Enter Email"
          value={values.email}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.email && touched.email ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.email && errors.email ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.email}</p>
        ) : null}
      </div>
    </div>

    <div className="flex flex-col md:flex-row justify-between gap-3 md:gap-5 mt-3 md:mt-5">
      <div className="w-full mb-3 md:mb-0">
        <label className="block mb-1">Height:</label>
        <input
          type="number"
          name="height"
          placeholder="Enter Height"
          value={values.height || ""}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.height && touched.height ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.height && errors.height ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.height}</p>
        ) : null}
      </div>
      <div className="w-full">
        <label className="block mb-1">Height Units:</label>
        <select
          name="height_units"
          placeholder="Select Height Units"
          value={values.height_units}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.height_units && touched.height_units
              ? "border-red-600"
              : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option value="ft">Feet (ft)</option>
          <option value="cm">Centimeter (cm)</option>
        </select>
        {touched.height_units && errors.height_units ? (
          <p className="text-red-500 pl-2 italic text-sm">
            {errors.height_units}
          </p>
        ) : null}
      </div>
    </div>

    <div className="flex flex-col md:flex-row justify-between gap-3 md:gap-5 mt-3 md:mt-5">
      <div className="w-full mb-3 md:mb-0">
        <label className="block mb-1">Weight:</label>
        <input
          type="number"
          name="weight"
          placeholder="Enter Weight"
          value={values.weight}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.weight && touched.weight ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.weight && errors.weight ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.weight}</p>
        ) : null}
      </div>
      <div className="w-full">
        <label className="block mb-1">Weight Units:</label>
        <select
          name="weight_units"
          placeholder="Select Weight Unit"
          value={values.weight_units}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.weight_units && touched.weight_units
              ? "border-red-600"
              : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option value="kg">Kilogram (kg)</option>
          <option value="lb">Pound (lb)</option>
        </select>
        {touched.weight_units && errors.weight_units ? (
          <p className="text-red-500 pl-2 italic text-sm">
            {errors.weight_units}
          </p>
        ) : null}
      </div>
    </div>

    {/* Take Trial Start and end date */}
    <div className="flex flex-col md:flex-row justify-between gap-3 md:gap-5 mt-3 md:mt-5">
      <div className="w-full mb-3 md:mb-0">
        <label className="block mb-1">Trial Start Date:</label>
        <input
          type="date"
          name="trial_start_date"
          value={values.trial_start_date}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.trial_start_date && touched.trial_start_date
              ? "border-red-600"
              : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.trial_start_date && errors.trial_start_date ? (
          <p className="text-red-500 pl-2 italic text-sm">
            {errors.trial_start_date}
          </p>
        ) : null}
      </div>
      <div className="w-full">
        <label className="block mb-1">Trial End Date:</label>
        <input
          type="date"
          name="trial_end_date"
          value={values.trial_end_date}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.trial_end_date && touched.trial_end_date
              ? "border-red-600"
              : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.trial_end_date && errors.trial_end_date ? (
          <p className="text-red-500 pl-2 italic text-sm">
            {errors.trial_end_date}
          </p>
        ) : null}
      </div>
    </div>
    <div className="w-full md:w-1/2 mt-3 md:mt-5">
      <label className="block mb-1">Disease/Medical Condition:</label>
      <input
        type="text"
        name="disease"
        placeholder="Enter Disease/Medical Condition"
        value={values.disease}
        className={
          "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
          (errors.disease && touched.disease ? "border-red-600" : "")
        }
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {touched.disease && errors.disease ? (
        <p className="text-red-500 pl-2 italic text-sm">{errors.disease}</p>
      ) : null}
    </div>

    <h1 className="font-bold text-md md:text-lg text-gx-ink-soft py-2 border-t mt-3 md:mt-5">
      Visitor Address & Location Details:
    </h1>

    <div className="flex flex-col md:flex-row justify-between gap-3 md:gap-5 mt-3">
      <div className="w-full mb-3 md:mb-0">
        <label className="block mb-1">
          Address <span className="text-red-600">*</span>
        </label>
        <input
          type="text"
          name="address"
          placeholder="Enter Address"
          value={values.address}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.address && touched.address ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.address && errors.address ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.address}</p>
        ) : null}
      </div>

      <div className="w-full">
        <label className="block mb-1">
          Postal Code <span className="text-red-600">*</span>
        </label>
        <input
          type="text"
          name="postal_code"
          placeholder="Enter Potal Code"
          value={values.postal_code}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.postal_code && touched.postal_code
              ? "border-red-600"
              : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.postal_code && errors.postal_code ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.postal_code}</p>
        ) : null}
      </div>
    </div>

    <div className="flex flex-col lg:flex-row justify-between gap-3 md:gap-5 mt-3 md:mt-5">
      <div className="w-full mb-3 lg:mb-0">
        <label className="block mb-1">
          Country <span className="text-red-600">*</span>
        </label>
        <select
          name="country"
          placeholder="Enter Country"
          value={values.country}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.country && touched.country ? "border-red-600" : "")
          }
          onChange={(e) => {
            handleChange(e);
            getStates(e.target.value);
            getCities(e.target.value);
          }}
          onBlur={handleBlur}
        >
          <option value="">Country</option>
          {countries?.map((country, index) => (
            <option key={index} value={country.isoCode}>
              {country.name}
            </option>
          ))}
        </select>
        {touched.country && errors.country ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.country}</p>
        ) : null}
      </div>
      <div className="w-full mb-3 lg:mb-0">
        <label className="block mb-1">
          State<span className="text-red-600">*</span>
        </label>
        <select
          name="state"
          placeholder="Enter State"
          value={values?.location_id?.state}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.state && touched.state ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option value="">State </option>
          {states?.map((state, index) => (
            <option key={index} value={state.isoCode}>
              {state.name}
            </option>
          ))}
        </select>
        {touched.state && errors.state ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.state}</p>
        ) : null}
      </div>
      <div className="w-full">
        <label className="block mb-1">
          City <span className="text-red-600">*</span>
        </label>
        <select
          name="city"
          placeholder="Enter City"
          value={values?.location_id?.city}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.city && touched.city ? "border-red-600" : "")
          }
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option value="">City</option>
          {cities?.map((city, index) => (
            <option key={index} value={city.name}>
              {city.name}
            </option>
          ))}
        </select>
        {touched.city && errors.city ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.city}</p>
        ) : null}
      </div>
    </div>

    {role !== "ClubAdmin" ? (
      <div className="w-full md:w-1/2 mt-3 md:mt-5">
        <label className="block mb-1">
          Location <span className="text-red-600">*</span>
        </label>
        <select
          name="location_id"
          value={values?.location_id?._id}
          className={
            "border border-gx-border bg-gx-canvas w-full p-2 rounded-xl outline-0 " +
            (errors.location_id && touched.location_id
              ? "border-red-600"
              : "")
          }
          onChange={(e) => handleChange(e)}
          onBlur={handleBlur}
        >
          <option value="">Select Location</option>
          {locations?.map((location, index) => (
            <option key={index} value={location._id}>
              {location.name}
            </option>
          ))}
        </select>
        {touched.location_id && errors.location_id ? (
          <p className="text-red-500 pl-2 italic text-sm">{errors.location_id}</p>
        ) : null}
      </div>
    ) : (
      <input
        type="hidden"
        name="location_id"
        value={values.location_id}
      />
    )}

    <div className="flex justify-end items-center pt-3 mt-3 md:mt-5 border-t">
      <button
        type="submit"
        className={`bg-blue-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-blue-700 text-sm md:text-base ${buttonLoading ? "flex cursor-not-allowed bg-gray-400" : ""}`}
      >
        {buttonLoading ? 'Submitting...' : 'Submit'}
        {buttonLoading && (
          <CircularProgress size={20} className="ml-2 mt-1" />
        )}
      </button>
    </div>
  </form>
</CustomModal>

      <CustomModal
        isModal={isViewModalOpen}
        handleModal={toggleViewModal}
        size="2xl"
      >
        
          <div>
            <Tooltip title="" placement="bottom">
              <h1 className="font-bold text-3xl text-gx-ink-soft p-5 border-b mx-2">
                View Visitor
              </h1>
              <div className="m-14">
                <Box>
                  {/* Display Visitor Image in center with fixed height and width */}
                  <div className="flex justify-center mb-5">
                    <img
                      src={encodedImagesURI(selectedVisitor?.photo) || defaultUser}
                      alt={selectedVisitor?.name}
                      className="w-32 h-32 object-cover rounded-full"
                    />
                  </div>

                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>{selectedVisitor?.name}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Email</TableCell>
                        <TableCell>{selectedVisitor?.email}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Phone Number</TableCell>
                        <TableCell>{selectedVisitor?.phone}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>Address</TableCell>
                        <TableCell>{selectedVisitor?.address}</TableCell>
                      </TableRow>
                      {/* <TableRow>
                        <TableCell>Salary</TableCell>
                        <TableCell>{selectedVisitor?.salary}</TableCell>
                      </TableRow> */}
                    </TableBody>
                  </Table>
                </Box>
              </div>
            </Tooltip>
          </div>
        
      </CustomModal>

      <CustomModal
        isModal={isDeleteModalOpen}
        handleModal={toggleDeleteModal}
        size="md"
      >
        <div className="m-5">
          <h2 className="text-xl font-medium">Delete Visitor?</h2>
          <p className="text-gx-ink-soft mt-3">
            Are you sure you want to delete this visitor?
          </p>
          <button
            className={`bg-red-600 p-2 px-5 rounded-lg text-white font-medium hover:bg-red-700 mt-5 float-right mb-5 ${buttonLoading ? "flex cursor-not-allowed bg-gray-400" : ""}`}
            onClick={deleteVisitor}
          >
            {buttonLoading ? 'Deleting...' : 'Delete Visitor'}
            {buttonLoading && (
              <CircularProgress size={20} className="ml-2" />
            )}
          </button>
        </div>
      </CustomModal>
      {isPopupOpen && (
        <Popup
          onClose={() => setIsPopupOpen(false)}
          alertType={
            isSuccessAlert ? "success" : isFaliureAlert ? "failure" : ""
          }
          message={
            isSuccessAlert
              ? successMessage
              : isFaliureAlert
              ? failureMessage
              : ""
          }
        />
      )}
      <VisitorStatsModal
        filtered_visitors={filtered_visitors}
        open={isStatsModalOpen}
        setOpen={setIsStatsModalOpen}
      />
    </>
  );
}

export default Visitor;
